module.exports = __webpack_public_path__ + "img/btnLogin.7134d38c.png";